var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project-head"},[_c('div',{staticClass:"username"},[_vm._v(_vm._s(_vm.username))]),_vm._v(" / "),_c('div',{staticClass:"project"},[_vm._v(_vm._s(_vm.projectName))])])}
var staticRenderFns = []

export { render, staticRenderFns }